import './ImportacaoRemuneracaoGerentes.css';
import { useRef, useState } from 'react';
import { post } from '../../services/api';
import AdminSection from '../AdminSection/AdminSection';
import DownloadIcon from '@mui/icons-material/Download';
import { TailSpin } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';

export default function ImportacaoRemuneracaoGerentes({ setNotifier }) {
    const navigate = useNavigate();

    const [valorBaseCSVFileName, setValorBaseCSVFileName] = useState(undefined);
    const [file, setFile] = useState(null);
    const inputRef = useRef(null);
    const [isFetchingDataImportacao, setIsFetchingDataImportacao] = useState(false);

    async function importarRemuneracao() {
        try {
            const idUsuario = localStorage.getItem('idusuario');
            const formData = new FormData();
            const authToken = localStorage.getItem('adminToken');

            formData.append('file', file);
            formData.append('idusuario', idUsuario);

            setIsFetchingDataImportacao(true);

            const response = await post('/admin/importarremuneracaogerentes', formData, authToken);

            setIsFetchingDataImportacao(false);

            if (response.Sucesso) {
                setNotifier(true, response.Mensagem);
            } else {
                setNotifier(false, response.Mensagem);
            }
            limparInput();
        } catch (error) {
            setIsFetchingDataImportacao(false);
            setNotifier(false, 'Erro durante a importação!');
            console.error('Erro durante a importação:', error);
        }
    }

    function baixarExemploCSV() {
        const link = document.createElement('a');
        link.href = `${process.env.PUBLIC_URL}/exemploRemuneracaoGerentes.csv`;
        link.download = 'exemploRemuneracaoGerentes.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function limparInput() {
        setFile(null);
        inputRef.current.value = null;
        setValorBaseCSVFileName(undefined);
    }

    return <>
        <AdminSection
            etapa={1} titulo={'Importar Cluster'}
            acoes={
                <button type="button" className='download-btn' onClick={baixarExemploCSV}>
                    <DownloadIcon style={{ width: '20px', height: '20px', marginRight: '8px' }} /> Exportar modelo
                </button>
            }
        >
            <div className='p-8' style={{ paddingBottom: '16px' }}>
                <div className='texto-csv'>
                    <span className='bold-text'>Importe seu arquivo clicando no botão abaixo</span>
                    <div className='normal-text'>O arquivo deve ser em formato CSV.</div>
                </div>

                <div className='importar-csv'>
                    <label htmlFor='file_input_remuneracao' className='btn-label'>Importar CSV</label>
                    <input type='file' accept='.csv' ref={inputRef} name='file_input_remuneracao' id='file_input_remuneracao' onChange={(e) => {
                        setValorBaseCSVFileName(e.target.files[0].name);
                        setFile(e.target.files[0]);
                    }} />
                    <label className='muda-nome'>{valorBaseCSVFileName === undefined ? '' : valorBaseCSVFileName}</label>
                </div>
            </div>

            {file && (
                <div className='animal-valorBase-buttons' style={{ textAlign: 'center', padding: '0px' }}>
                    <button
                        className='animal-refresh-btn'
                        onClick={limparInput}>Cancelar
                    </button>
                </div>
            )}
            <div className='button-container'>
                <button type='button' className='voltar-btn' onClick={() => navigate('/admin/remuneracao/gerentes')}>Voltar</button>

                <button type='button' className='animal-save-btn' onClick={importarRemuneracao}>
                    {isFetchingDataImportacao ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <TailSpin color='#ffffff' height={20} width={39} />
                        </div>
                    ) : (
                        'Enviar CSV'
                    )}
                </button>
            </div>
        </AdminSection>
    </>;
}
